module.exports = __webpack_public_path__ + "img/bold.fd2050cc.svg";